/**
 * 战报：默认纯文本 emoji 压缩格式（无链接 / Logo / 二维码）。
 * 邀请链接只在游戏内落地页与「复制邀请语」中由用户主动附带。
 */
import type { RankResult } from '../core/types';
import type { RunSummary } from './score';

const CAUSE_LABEL: Record<string, string> = {
  GREED: '贪刀',
  SURROUNDED: '被包围',
  CHARGED: '冲锋犬带走',
  BOMBED: '自爆菇带走',
  ELITE_COUNTER: '被精英克制',
  BOSS_SKILL: 'Boss 技能命中',
  ATTRITION: '消耗殆尽',
  SHIELD_CHIP: '护盾耗尽',
  TIMEOUT: '时间耗尽',
  VICTORY: '通关',
};

export function mmss(seconds: number): string {
  const t = Math.round(seconds);
  const m = Math.floor(t / 60);
  const s = t % 60;
  return `${m}:${String(s).padStart(2, '0')}`;
}

/** 纯战报：进化 · 存活/击杀 · 死法 · 总分（有快照位次时追加击败百分比）。 */
export function buildReport(s: RunSummary, rank?: RankResult | null): string {
  const outcome = s.cause === 'VICTORY'
    ? '✅ 通关' : `💀 死于${CAUSE_LABEL[s.cause] ?? s.cause}`;
  const parts = [
    `🔁⚔️ ${s.evolutions}/4 进化`,
    `🕐 ${mmss(s.time)} · 击杀 ${s.kills}`,
    outcome,
    `🏆 总分 ${s.score}`,
  ];
  if (rank) parts.push(`击败今日 ${rank.beatenPct}%`);
  return parts.join(' · ');
}

/** 复制邀请语：战报 + 落地页链接（仅在用户主动点击时生成）。 */
export function buildInvite(s: RunSummary, landingUrl: string): string {
  return `${buildReport(s)}\n来打今天的同题局：${landingUrl}`;
}
